export enum PermissionEnum {
	DEMANDEUR = "demandeur",
	ACHETEUR = "achat",
	MAGASINIER = "magasinier",
	SUPERVISEUR = "superviseur",
	ADMIN = "admin",
	SUPERVISEUR_ACHAT = "superieurAchat",
	CHEF_CHANTIER = "chefchantier",
	GESTIONNAIREBC = "gestionnairebc",
	GESTIONNAIRE_COMMERCIAL = "commercial",
	BET = "bet",
	RH = "rh",
	SUPERVISEUR_BET = "superviseurbet",
	CHIFFRAGE = "chiffrage",
	MAGASINIER_INFORMATIQUE = "magasinierinformatique",
	TRESORERIE = "tresorerie",
	TRESORERIE_BASIC = "tresoreriebasic",
	COLLABORATEUR = "collaborateur",
	CONTROLE_GESTION = "controlegestion",
	DIRECTION = "direction",
	FINANCE = "finance",
	COORDINATION_RH = "coordinationrh",
	MASTER_DATA = "masterdata",
	/** Responsable de projet : consultation des décomptes et validation des devis de ses projets. */
	RESPONSABLE_PROJET = "responsableprojet",
}

export type PriorityType =
	| PermissionEnum.CHEF_CHANTIER
	| PermissionEnum.DEMANDEUR
	| PermissionEnum.ACHETEUR
	| PermissionEnum.MAGASINIER
	| PermissionEnum.MASTER_DATA
	| PermissionEnum.SUPERVISEUR
	| PermissionEnum.ADMIN
	| PermissionEnum.SUPERVISEUR_ACHAT
	| PermissionEnum.GESTIONNAIREBC
	| PermissionEnum.BET
	| PermissionEnum.RH
	| PermissionEnum.SUPERVISEUR_BET
	| PermissionEnum.MAGASINIER_INFORMATIQUE
	| PermissionEnum.CHIFFRAGE
	| PermissionEnum.COLLABORATEUR
	| PermissionEnum.TRESORERIE
	| PermissionEnum.CONTROLE_GESTION
	| PermissionEnum.COORDINATION_RH
	| PermissionEnum.DIRECTION;
